import {
  actionTypes,
  supervisorsRequestSuccess,
  supervisorsRequestFailure,
  revisorRequestSuccess,
  revisorRequestFailure,
  groupsPerimeterRequestSuccess,
  groupsPerimeterRequestFailure,
  usersPerimeterRequestSuccess,
  usersPerimeterRequestFailure,
  applicationsPerimeterRequestFailure,
  applicationsPerimeterRequestSuccess,
  brPerimeterRequestFailure,
  brPerimeterRequestSuccess,
  entitlementsPerimeterRequestFailure,
  entitlementsPerimeterRequestSuccess,
  createCertificationRequestSuccess,
  createCertificationRequestFailure,
  editCertificationRequestSuccess,
  editCertificationRequestFailure,
  technicalUsersPerimeterRequestSuccess,
  technicalUsersPerimeterRequestFailure,
} from "./actions";

import {
  fetchSupervisorsAndRevisorsRequest,
  fetchUsersRequest,
  fetchApplicationsRequest,
  fetchBRRequest,
  fetchGroupsRequest,
  fetchEntitlementsRequest,
  createCertificationRequest,
  editCertificationRequest,
} from "./services";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError, debounceTime } from "rxjs/operators";
import { of } from "rxjs";
import { adminTechnicalUsersGetAllTU } from "../../../service/technicalUserService";

const fetchSupervisorsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SUPERVISORS_REQUEST),
    debounceTime(100),
    mergeMap((action: { payload: any }) =>
      fetchSupervisorsAndRevisorsRequest(action.payload).pipe(
        map((response: any) => supervisorsRequestSuccess(response)),
        catchError((error: any) => of(supervisorsRequestFailure(error)))
      )
    )
  );

const fetchRevisorsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REVISOR_REQUEST),
    debounceTime(100),
    mergeMap((action: { payload: any }) =>
      fetchSupervisorsAndRevisorsRequest(action.payload).pipe(
        map((response: any) => revisorRequestSuccess(response)),
        catchError((error: any) => of(revisorRequestFailure(error)))
      )
    )
  );

const fetchUsersRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USERS_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchUsersRequest(action.payload).pipe(
        map((response: any) => usersPerimeterRequestSuccess(response)),
        catchError((error: any) => of(usersPerimeterRequestFailure(error)))
      )
    )
  );

const fetchGroupsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GROUPS_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchGroupsRequest(action.payload).pipe(
        map((response: any) => groupsPerimeterRequestSuccess(response)),
        catchError((error: any) => of(groupsPerimeterRequestFailure(error)))
      )
    )
  );

const fetchApplicationsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.APPLICATIONS_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchApplicationsRequest(action.payload).pipe(
        map((response: any) => applicationsPerimeterRequestSuccess(response)),
        catchError((error: any) =>
          of(applicationsPerimeterRequestFailure(error))
        )
      )
    )
  );

const fetchBRRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.BR_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchBRRequest(action.payload).pipe(
        map((response: any) => brPerimeterRequestSuccess(response)),
        catchError((error: any) => of(brPerimeterRequestFailure(error)))
      )
    )
  );

const fetchEntitlementsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ENTITLEMENTS_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      fetchEntitlementsRequest(action.payload).pipe(
        map((response: any) => entitlementsPerimeterRequestSuccess(response)),
        catchError((error: any) =>
          of(entitlementsPerimeterRequestFailure(error))
        )
      )
    )
  );

const fetchTechnicalUsersRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.TECHNICAL_USERS_PERIMETER_REQUEST),
    mergeMap((action: { payload: any }) =>
      adminTechnicalUsersGetAllTU().pipe(
        map((response: any) => technicalUsersPerimeterRequestSuccess(response)),
        catchError((error: any) =>
          of(technicalUsersPerimeterRequestFailure(error))
        )
      )
    )
  );

const createCertificationRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_CERTIFICATION_REQUEST),
    mergeMap((action: { payload: any }) =>
      createCertificationRequest(action.payload).pipe(
        map((response: any) => createCertificationRequestSuccess(response)),
        catchError((error: any) => of(createCertificationRequestFailure(error)))
      )
    )
  );

const editCertificationRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_CERTIFICATION_REQUEST),
    mergeMap((action: { payload: any }) =>
      editCertificationRequest(action.payload).pipe(
        map((response: any) => editCertificationRequestSuccess(response)),
        catchError((error: any) => of(editCertificationRequestFailure(error)))
      )
    )
  );
export default [
  fetchSupervisorsRequestEpic,
  fetchRevisorsRequestEpic,
  fetchEntitlementsRequestEpic,
  fetchBRRequestEpic,
  fetchApplicationsRequestEpic,
  fetchGroupsRequestEpic,
  fetchUsersRequestEpic,
  createCertificationRequestEpic,
  editCertificationRequestEpic,
  fetchTechnicalUsersRequestEpic,
];
